<template>
  <div class="profile-field" ref="profile-field">
        <v-container fluid py-0>
          <v-layout row wrap>
            <v-flex xs5 class="col-field">
              <span class="text">
                {{field.label}}
              </span>
            </v-flex>
            <v-flex xs4 class="col-field">
              <!-- V-SELECT spécial for LANGUAGE -->
              <v-select 
                v-if="editing && (field.key === 'language')" 
                :items="['EN', 'FR']"
                v-model="value"
              />
              <v-text-field
                @keypress.enter="updateProfil"
                v-else-if="editing"
                v-model="value"
              ></v-text-field>
              <span v-else class="text">
                {{value}} 
              </span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex v-if="!field.readonly" xs2 class="col-field">
              <!-- <button v-if="editing" @click="updateProfil" class="btn check"> <v-icon>mdi-check</v-icon></button> -->
              <button @click="updateProfil" @mouseenter="hoverEdit = true" @mouseleave="hoverEdit = false" class="btn btn-edit"> 
                <span>
                  <v-icon>mdi-check</v-icon>
                </span>
                <span :class="{'hide': editing}">{{$t('buttons.edit')}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Calque_2" x="0px" y="0px" viewBox="0 0 1842.53 578.33" enable-background="new 0 0 1842.53 578.33" xml:space="preserve">
                  <polygon class="editing-icon-svg" fill="none" stroke="#f1e341" stroke-width="39" stroke-miterlimit="10" points="195.56,19.5 1635.48,19.5 1818.94,275.24 1635.48,558.78 193.87,550.73 23.21,280.8 "/>
                  <polygon :class="{'hide': editing || hoverEdit}" fill="none" stroke="#FFFFFF" class="editing-icon-svg" stroke-width="39" stroke-miterlimit="10" points="195.56,19.5 1635.48,19.5 1818.94,275.24 1635.48,558.78 193.87,550.73 23.21,280.8 "/>
                </svg>
              </button>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
</template>

<script>
export default {
  props: {
    dataProfile: Object,
    field: Object
  },
  beforeMount() {
    let value = this.dataProfile[this.field.key];
    let level = value === 'B'
      || value === 'S'
      || value === 'G'
      || value === 'D';
    if (this.field.key === 'account_level' && level) {
      switch (value) {
        case 'B':
          value = 'Bronze'
          break;
        case 'S':
          value = 'Silver'
          break;
        case 'G':
          value = 'Gold'
          break;
        case 'D':
          value = 'Diamond'
          break;
        default:
          break;
      }
    }
    this.value = value;
  },
  data() {
    return {
      editing: false,
      value: '',
      hoverEdit: false
    }
  },
  methods: {
    async updateProfil() {
      if (this.editing === false) {
        this.editing = true;
        setTimeout(() => {
          let input = this.$refs['profile-field'].querySelector('input');
          input.focus();
        }, 0);
        return;
      }
      this.dataProfile[this.field.key] = this.value;
      try {
        if (this.field.from === 'profile')
          var updatedResp = await this.$store.dispatch('users/updateProfil', this.dataProfile);
        else if (this.field.from === 'user')
          var updatedResp = await this.$store.dispatch('users/updateUser', this.dataProfile);
        this.editing = false;
      } catch(err) {
        console.error(err);
      }
    }
  }

}
</script>

<style lang="sass" scoped>
$active: #f1e341
.profile-field
  height: 5.4rem
  display: flex
  margin-bottom: 1.5rem
  padding: 0.3rem 3.5rem
  background-color: #262626
  button 
    color: white
  .col-field
    font-size: 1.4rem
    display: flex 
    align-items: center
    &:last-child
      justify-content: center
    .v-input
      font-size: 1.4rem
      margin-bottom: -3px
    button
      font-size: 1.4rem
    .text
      // border-bottom: 2px transparent
  .btn-edit 
    width: 140px
    position: relative
    span 
      background-color: #262626
      opacity: 1
      transition: all ease .2s
      padding: 0 1rem
      position: absolute
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      width: max-content
      i 
        font-size: 1.8rem
        color: $active
      &.hide
        opacity: 0
    .editing-icon-svg
      opacity: 1
      transition: all ease .5s
      &.hide
        opacity: 0
    svg 
      position: absolute
      left: 0
      top: 50%
      transform: translateY(-50%)

</style>
